import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Tree } from 'primereact/tree';
import { RootState } from '../../../store';
import { IUor, IVisibilita } from '../../../shared/interfaces';
import { Visibilita_ViewMode, Visibility_Type } from '../../../shared/enums';
import VisibilitaNodeTemplate from './VisibilitaNodeTemplate';
import uorsService from '../../../services/uors.service';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { Toggle } from '@fluentui/react';
import TreeNode from 'primereact/treenode';



export interface VisibilitaProps {
    readOnlyMode?: boolean
    visibilita?: IVisibilita[]
    extraCssClass?: string
    viewMode?: Visibilita_ViewMode
    onUpdateVisibilitaHandler: (visibilita: IVisibilita[]) => void
}


const Visibilita: React.FunctionComponent<VisibilitaProps> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const [organigrammaFlatArray, setOrganigrammaFlatArray] = useState<IUor[]>([]);
    const [organigrammaNodes, setOrganigrammaNodes] = useState<any[]>([]);
    const [organigrammaExpandedNodes, setOrganigrammaExpandedNodes] = useState({});
    const [visibilitaNodes, setVisibilitaNodes] = useState<IVisibilita[]>([]);
    const [showOnlyVisibilita, setShowOnlyVisibilita] = useState<boolean>();
    const [activeVisibilityNodes, setActiveVisibilityNodes] = useState<TreeNode[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setOrganigramma();
    }, [currentAoo]); // Eseguito solo quando viene aggiornata la variabile currentAoo


    const setOrganigramma = () => {
        let _visibilita = props.visibilita ? props.visibilita : [];
        setLoading(true);
        if (currentAoo)
            uorsService.getOrganigrammaAoo(currentAoo.id)
                .then(uors => {
                    let expandedNodes = {};
                    let organigrammaFlat: IUor[] = []
                    /// Rimappo le uor nel formato TreeNode di prime react, setto tutti i nodi come aperti 
                    /// e creo l'array organigrammaFlat che utilizzo per facilitare la ricerca di una uor nell'organigramma
                    let organigramma = remapOrganigrammaNodes(uors, expandedNodes, organigrammaFlat);

                    setOrganigrammaFlatArray(organigrammaFlat);
                    setOrganigrammaNodes(organigramma);
                    setOrganigrammaExpandedNodes(expandedNodes);


                    /// Aggiorno la visibilità di tipo IVisibilita_Type.Visibilita 
                    /// Prima rimuovo tutte le visibilità di tipo IVisibilita_Type.Visibilita 
                    /// e poi le ricalcolo in maniera ricorsiva in base alle visibilità selezionate
                    let visibilitaAggiornata = _visibilita.filter(n => n.tipologia !== Visibility_Type.Visibilita);
                    visibilitaAggiornata.forEach(item => {
                        let uor = organigrammaFlat.find(el => el.id === item.uor.id);
                        aggiornaVisibilitaParentNodes(uor!.parentId!, visibilitaAggiornata, organigrammaFlat);
                    });

                    setVisibilitaNodes(visibilitaAggiornata);

                    // se sono in protocol viewer filtro le uor con visibilità aggiornata per mostrarle di default
                    // click sul toggle farà apparire tutto l'albero
                    if (props.viewMode === Visibilita_ViewMode.ActiveOnly) {
                        let filteredNodesByVisibilita = remapActiveVisibilityNodes(uors, expandedNodes);
                        setActiveVisibilityNodes(filteredNodesByVisibilita);
                    } else {
                        setActiveVisibilityNodes(organigramma);
                    }

                    setLoading(false);
                    props.onUpdateVisibilitaHandler(visibilitaAggiornata);
                })

    }
    const remapOrganigrammaNodes = (uorList, expandedNodes: any, organigrammaFlat: any[]) => {
        let uors = uorList.map(uorItem => {
            if (uorItem.children && uorItem.children.length)
                expandedNodes[uorItem.id] = true
            organigrammaFlat.push({
                id: uorItem.id,
                nome: uorItem.nome,
                sigla: uorItem.sigla,
                parentId: uorItem.parentId

            });
            let children = remapOrganigrammaNodes(uorItem.children, expandedNodes, organigrammaFlat)
            return { ...uorItem, key: uorItem.id, label: uorItem.nome, children: children }

        });
        return uors;
    }

    // rimappo solamente i nodi con visibilità attiva e ricostruisco l'albero con i soli nodi in visibilità
    // per far sì che di default si veda l'organigramma delle uor in visibilità, da poter switchare
    // con l'intero organigramma attraverso il pulsante toggle
    const remapActiveVisibilityNodes = (uorList, expandedNodes: any) => {
        let filteredUors: any[] = [];
        let visibilita = props.visibilita ? props.visibilita : [];
        uorList.forEach(u => {
            if (visibilita.some(v => v.uor.id === u.id)) {
                expandedNodes[u.id] = true;
                filteredUors.push({
                    ...u,
                    key: u.id,
                    label: u.nome,
                    children: remapActiveVisibilityNodes(u.children, expandedNodes),
                });
            }
        });
        return filteredUors;
    }

    const setVisibilita = (visibilitaItem: IVisibilita | undefined, tipoVisibilita: Visibility_Type, uorNode) => {
        let _visibilita: any[] = [];


        // se nella array della visibilità c'è già la uor cliccata allora l'aggiorno altrimenti l'aggiungo
        if (visibilitaItem) {

            let uorWillRemoved: any;
            // rimappo la visibilità creando un nuovo array nodes
            visibilitaNodes.forEach((item) => {
                let newItem: IVisibilita = { ...item };
                if (newItem.uor.id === visibilitaItem.uor.id) {
                    // se ho cambiato tipologia aggiorno la visibilità della uor e l'aggiungo al nuovo array nodes
                    if (newItem.tipologia !== tipoVisibilita) {
                        newItem.tipologia = tipoVisibilita;
                        _visibilita.push(newItem);
                    }
                    // se invece riclicco sulla stessa tipologia significa che voglio rimuovere la visibilità
                    // e quindi NON aggiungo la uor all'array nodes e segno da rimuovere, successivamente uso 
                    // il metodo aggiornaVisibilitaChildrenNodes per rimuovere anche tutti i suoi figli
                    else {
                        uorWillRemoved = visibilitaItem.uor;
                    }
                }
                else
                    _visibilita.push(newItem);

            });

            /// Se ho rimosso una visibilità rimuovo anche tutti i suoi figli
            _visibilita = [...aggiornaVisibilitaChildrenNodes(uorWillRemoved, _visibilita)];
        }
        else {
            let uor = {
                id: uorNode.id,
                nome: uorNode.nome,
                sigla: uorNode.sigla,
                parentId: uorNode.parentId
            }
            _visibilita = visibilitaNodes.slice();
            _visibilita.push({ uor: { ...uor }, tipologia: tipoVisibilita })
        }

        /// Aggiorno la visibilità di tipo IVisibilita_Type.Visibilita 
        /// Prima rimuovo tutte le visibilità di tipo IVisibilita_Type.Visibilita 
        /// e poi le ricalcolo in maniera ricorsiva in base alle visibilità selezionate
        let visibilitaAggiornata = _visibilita.filter(n => n.tipologia !== Visibility_Type.Visibilita);
        visibilitaAggiornata.forEach(item => {
            let uor = organigrammaFlatArray.find(el => el.id === item.uor.id);
            aggiornaVisibilitaParentNodes(uor!.parentId!, visibilitaAggiornata, organigrammaFlatArray);
        });

        setVisibilitaNodes(visibilitaAggiornata);

        /// Aggiorno lo stato del protocollo nel parent component 
        props.onUpdateVisibilitaHandler(visibilitaAggiornata);

    }

    const aggiornaVisibilitaParentNodes = (uorId: number, visibilita: IVisibilita[], organigrammaFlat: IUor[]) => {

        let uor = organigrammaFlat.find(u => u.id === uorId);

        if (uor && visibilita.findIndex(el => el.uor.id === uorId) < 0) {
            visibilita.push({ uor: { ...uor }, tipologia: Visibility_Type.Visibilita })
        }
        if (uor && uor.parentId) {

            aggiornaVisibilitaParentNodes(uor.parentId, visibilita, organigrammaFlat);
        }

    }

    const aggiornaVisibilitaChildrenNodes = (uor, visibilita: IVisibilita[]) => {

        if (uor) {
            visibilita = [...visibilita.filter(it => it.uor.id !== uor.id)];

            uor.children?.forEach((item) => {

                visibilita = [...aggiornaVisibilitaChildrenNodes(item, visibilita)];

            });

        }
        return visibilita;

    }


    const organigrammaNodeTemplate = (uorNode) => {
        let visibilitaItem = visibilitaNodes.find(v => v.uor.id === uorNode.id);

        return (

            <VisibilitaNodeTemplate
                readOnlyMode={props.readOnlyMode}
                uorNode={uorNode}
                visibilitaItem={visibilitaItem}
                onVisibilitaChangedHandler={(tipologia) => { setVisibilita(visibilitaItem, tipologia, uorNode) }} />
        );
    };

    const onChangeToggle = (ev: any, checked?: boolean) => {

        setShowOnlyVisibilita(checked!);

        let filteredNodesByVisibilita = remapActiveVisibilityNodes(organigrammaNodes, organigrammaExpandedNodes);

        if ((props.viewMode === Visibilita_ViewMode.ActiveOnly && showOnlyVisibilita)
            || (props.viewMode === Visibilita_ViewMode.Expanded && checked)) {
            setActiveVisibilityNodes(filteredNodesByVisibilita);
        } else {
            setActiveVisibilityNodes(organigrammaNodes);
        }

    };

    return (
        <div className={`visibilita flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={'my-scroll-div'}>
                <div className={`my-component-content`}>

                    <Toggle
                        label=""
                        checked={showOnlyVisibilita}
                        onText={props.viewMode === Visibilita_ViewMode.ActiveOnly ? "Mostra solo le UOR in visibilità" : "Mostra tutto l'organigramma"}
                        offText={props.viewMode === Visibilita_ViewMode.ActiveOnly ? "Mostra tutto l'organigramma" : "Mostra solo le UOR in visibilità"}
                        onChange={onChangeToggle}
                        role="checkbox"></Toggle>


                    <Tree
                        value={activeVisibilityNodes}
                        expandedKeys={organigrammaExpandedNodes}
                        nodeTemplate={organigrammaNodeTemplate}
                        filter filterMode="strict"
                        filterPlaceholder="Inserire il nome della UOR"
                        onToggle={e => setOrganigrammaExpandedNodes(e.value)}
                    />

                </div>
            </div>



        </div>
    )

}

export default Visibilita;






